var _rect, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaoComCelular(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 229,
    viewBox: "0 0 314 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9666_11602)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 314,
    height: 229,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9666_11602",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 7,
    width: 305,
    height: 222
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M326 108.03C326 155.996 260.033 229 184.202 229C108.37 229 21 208.727 21 160.761C21 133.352 26.5932 98.2467 57.9475 82.3293C81.4636 70.3911 142.781 7 175.281 7C251.112 7 326 60.0639 326 108.03Z",
    fill: "#F0EFEF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9666_11602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.06 89.4254C138.431 93.5342 132.946 94.7688 128.783 92.1888L102.783 75.2142C98.636 72.6094 97.3898 67.1757 99.994 63.0514C102.623 58.9426 108.108 57.708 112.271 60.288L138.271 77.2626C142.418 79.8674 143.665 85.3011 141.06 89.4254Z",
    fill: "url(#paint0_linear_9666_11602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.624 88.4962C137.181 92.317 132.081 93.4654 128.211 91.0665L104.042 75.274C100.185 72.8535 99.0258 67.8016 101.447 63.9672C103.89 60.1464 108.99 58.998 112.86 61.3969L137.032 77.1763C140.896 79.5982 142.055 84.6598 139.624 88.4962Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.977 170.047C222.972 159.656 214.466 151.237 203.977 151.242C194.86 151.246 187.033 157.668 185.329 166.54L126.966 164.975L127.627 174.906C127.627 174.906 119.306 193.929 163.043 199.005V218.239H213.616V186.278C219.422 182.897 222.984 176.72 222.977 170.047Z",
    fill: "url(#paint1_linear_9666_11602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.006 178.244C121.706 183.596 125.362 194.754 159.437 198.399V216.822H211.964V168.025L121.979 165.797L122.008 166.227C122.26 170.229 122.259 174.242 122.006 178.244Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M199.774 21.553L122.022 21.7409C120.259 21.7453 118.832 23.1643 118.835 24.9114L119.198 168.983C119.203 170.731 120.637 172.145 122.401 172.14L200.154 171.952C201.918 171.948 203.345 170.527 203.341 168.779L202.98 24.7104C202.975 22.9624 201.541 21.5486 199.777 21.553C199.776 21.553 199.775 21.553 199.774 21.553Z",
    fill: "url(#paint2_linear_9666_11602)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.563 23.7001L198.246 23.5193C200.23 23.5146 201.843 25.1043 201.848 27.07L202.191 166.353C202.196 168.319 200.591 169.916 198.607 169.921L123.923 170.102C121.939 170.107 120.327 168.517 120.322 166.551L119.979 27.2681C119.974 25.3023 121.578 23.7048 123.563 23.7001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.479 27.2311C180.997 30.4392 178.225 32.8201 174.952 32.8389L146.673 32.9067C143.399 32.9044 140.615 30.5368 140.117 27.3303L125.138 27.3668C123.421 27.3712 122.032 28.7527 122.035 30.4538L122.359 163.354C122.364 165.055 123.758 166.431 125.475 166.428L197.022 166.256C198.739 166.251 200.127 164.87 200.125 163.169L199.798 30.2685C199.793 28.5674 198.399 27.1917 196.682 27.1946L181.479 27.2311Z",
    fill: "#F5D775"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.577 29.1723L168.764 28.9166C169.055 28.9121 169.294 29.1423 169.299 29.4306L169.3 29.5167C169.305 29.8048 169.072 30.042 168.781 30.0465L151.594 30.3022C151.303 30.3066 151.063 30.0765 151.059 29.7881L151.058 29.702C151.053 29.4137 151.286 29.1767 151.577 29.1723Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.185 29.9821C173.563 29.9765 173.865 29.6682 173.859 29.2935C173.854 28.9189 173.542 28.6197 173.164 28.6253C172.786 28.6309 172.484 28.9392 172.49 29.3139C172.495 29.6886 172.807 29.9877 173.185 29.9821Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M167.568 154.645C167.824 151.071 165.108 147.968 161.5 147.714C157.893 147.46 154.761 150.151 154.504 153.725C154.248 157.299 156.964 160.402 160.572 160.656C164.179 160.91 167.311 158.219 167.568 154.645Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.034 158.756C163.582 158.756 165.648 156.71 165.648 154.185C165.648 151.66 163.582 149.613 161.034 149.613C158.485 149.613 156.419 151.66 156.419 154.185C156.419 156.71 158.485 158.756 161.034 158.756Z",
    stroke: "#F5D775",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M139.053 150.247H131.104V158.122H139.053V150.247Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M189.965 151.379V150.513C189.965 150.369 189.847 150.252 189.702 150.252H186.628C186.483 150.252 186.365 150.369 186.365 150.513V151.379H185.174V150.857H184.468V151.379H183.586V156.616H192.75V151.379H189.965Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.085 42.52H121.982V139.587H200.085V42.52Z",
    fill: "url(#paint3_linear_9666_11602)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M191.667 38.5823C192.829 38.5823 193.772 37.6488 193.772 36.4973C193.772 35.3458 192.829 34.4124 191.667 34.4124C190.505 34.4124 189.562 35.3458 189.562 36.4973C189.562 37.6488 190.505 38.5823 191.667 38.5823Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M193.07 40.6672C194.233 40.6672 195.175 39.7338 195.175 38.5823C195.175 37.4308 194.233 36.4973 193.07 36.4973C191.908 36.4973 190.966 37.4308 190.966 38.5823C190.966 39.7338 191.908 40.6672 193.07 40.6672Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M190.031 40.6672C191.194 40.6672 192.136 39.7338 192.136 38.5823C192.136 37.4308 191.194 36.4973 190.031 36.4973C188.869 36.4973 187.927 37.4308 187.927 38.5823C187.927 39.7338 188.869 40.6672 190.031 40.6672Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M127.36 34.4124L130.634 36.4973L125.956 38.5823L128.295 40.6673",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M145.132 80.7461H121.982V139.59H145.132V80.7461Z",
    fill: "#F5D775"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M189.328 125.689H177.87V139.59H189.328V125.689Z",
    fill: "#F5D775"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M199.152 114.106H189.33V139.819H199.152V114.106Z",
    fill: "#F5D775"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.851 139.587H138.11C138.11 139.587 136.949 99.0464 141.851 86.5366H142.786C142.786 86.5366 139.52 132.406 141.851 139.587Z",
    fill: "#FFF8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.288 84.4517C139.288 84.4517 136.248 92.802 137.652 96.4996C137.652 96.4996 139.759 88.8539 142.212 87.6952C144.664 86.5366 147.24 96.4996 147.24 96.4996C147.24 96.4996 148.644 90.2369 146.07 85.1484C146.07 85.1484 151.214 87.9275 153.788 93.256C153.788 93.256 154.257 89.7802 148.175 82.599C148.175 82.599 153.553 83.9898 157.062 87.2334C157.062 87.2334 158.231 84.6839 150.983 80.514C150.983 80.514 151.918 77.5027 157.531 78.8935C157.531 78.8935 157.531 74.9558 148.644 75.6499C148.644 75.6499 148.644 73.1005 154.488 73.5624C154.488 73.5624 154.488 70.3188 147.706 71.4748C147.706 71.4748 149.11 69.3872 150.045 68.9253C150.045 68.9253 148.175 68.6931 146.771 69.8517C146.771 69.8517 147.005 65.6765 143.497 64.0613L143.028 69.8517C143.028 69.8517 139.098 65.2616 139.988 66.1462C140.223 66.3785 140.923 69.1576 140.689 70.5484C140.689 70.5484 136.714 67.3049 131.802 70.7807C131.802 70.7807 137.881 71.2452 138.816 73.3301C138.816 73.3301 133.672 72.4038 132.495 73.0979C132.495 73.0979 136.469 74.4887 136.235 75.4151C136.235 75.4151 129.221 75.4151 128.286 77.9645C128.286 77.9645 135.534 78.8909 136.003 79.585C136.003 79.585 127.575 85.6077 127.116 87.2308C127.116 87.2308 135.769 82.1345 137.17 82.1345C138.571 82.1345 130.849 89.548 131.325 91.4007C131.336 91.4007 137.649 83.9898 139.288 84.4517Z",
    fill: "#C8E6C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.935 118.247C144.935 118.247 134.55 121.616 137.181 139.59H142.091L147.949 121.235L144.935 118.247Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.248 118.247C177.248 118.247 187.286 122.078 184.652 140.052L179.832 140.015L174.232 121.227L177.248 118.247Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.366 88.7964C145.366 88.7964 140.625 112.942 138.041 111.661C138.041 111.661 162.982 133.001 185.002 111.661C185.002 111.661 181.125 94.3441 175.52 88.7964H145.366Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.355 105.868C171.586 105.868 179.88 97.651 179.88 87.5152C179.88 77.3795 171.586 69.1628 161.355 69.1628C151.124 69.1628 142.83 77.3795 142.83 87.5152C142.83 97.651 151.124 105.868 161.355 105.868Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M180.071 140.015C180.071 140.015 182.226 135.318 180.503 129.345C178.781 123.372 180.071 128.917 180.071 128.917L177.056 118.247H144.747L141.731 131.051C141.731 131.051 139.961 136.98 142.163 139.587",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.249 118.247H144.935L141.919 131.051C141.919 131.051 138.919 139.545 142.351 139.587C180.444 140.052 142.562 139.587 180.264 140.015C180.264 140.015 182.419 135.318 180.696 129.345C178.974 123.372 180.264 128.917 180.264 128.917L177.249 118.247Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M154.846 107.624H167.771V122.513C167.771 123.483 166.978 124.27 165.999 124.27H156.616C155.637 124.27 154.844 123.483 154.844 122.513V107.624H154.846Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.846 107.144H167.771V122.036C167.771 123.006 166.978 123.792 165.999 123.792H156.616C155.637 123.792 154.844 123.006 154.844 122.036V107.144H154.846Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M154.867 108.994C159.033 110.536 163.618 110.549 167.792 109.03V107.465H154.867V108.994Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.355 109.852C171.586 109.852 179.88 101.636 179.88 91.4999C179.88 81.3641 171.586 73.1475 161.355 73.1475C151.124 73.1475 142.83 81.3641 142.83 91.4999C142.83 101.636 151.124 109.852 161.355 109.852Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.644 84.5273H178.97C178.97 84.5273 175.954 70.3944 162.6 71.2947C149.246 72.1949 143.644 84.5273 143.644 84.5273Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.212 93.9188C144.163 93.9188 144.934 92.4853 144.934 90.717C144.934 88.9486 144.163 87.5151 143.212 87.5151C142.261 87.5151 141.489 88.9486 141.489 90.717C141.489 92.4853 142.261 93.9188 143.212 93.9188Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.402 93.9188C180.354 93.9188 181.125 92.4853 181.125 90.717C181.125 88.9486 180.354 87.5151 179.402 87.5151C178.451 87.5151 177.68 88.9486 177.68 90.717C177.68 92.4853 178.451 93.9188 179.402 93.9188Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M143.644 85.0021H178.97C178.97 85.0021 175.954 70.8693 162.6 71.7695C149.246 72.6698 143.644 85.0021 143.644 85.0021Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.771 188.684C212.814 188.684 220.956 180.618 220.956 170.669C220.956 160.719 212.814 152.653 202.771 152.653C192.728 152.653 184.586 160.719 184.586 170.669C184.586 180.618 192.728 188.684 202.771 188.684Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.527 173.844C209.259 175.052 205.626 171.644 204.407 166.418L192.291 121.796C191.082 116.549 194.377 111.321 199.666 110.092C204.962 108.895 210.239 112.159 211.479 117.399L221.378 163.164C222.587 168.406 219.816 172.636 214.527 173.844Z",
    fill: "url(#paint4_linear_9666_11602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.181 112.368C204.635 111.349 209.079 114.099 210.108 118.511L221.259 166.325C222.288 170.737 219.512 175.14 215.059 176.16C210.606 177.179 206.161 174.429 205.132 170.017L193.981 122.203C192.952 117.791 195.728 113.388 200.181 112.368Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.56 141.716C134.964 145.769 129.554 146.989 125.444 144.449L108.007 133.272C103.916 130.7 102.685 125.341 105.249 121.269C107.845 117.216 113.254 115.996 117.365 118.537L134.802 129.713C138.893 132.285 140.124 137.644 137.56 141.716Z",
    fill: "url(#paint5_linear_9666_11602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.185 165.377C130.564 169.473 125.097 170.704 120.947 168.132L110.148 160.327C106.013 157.731 104.771 152.315 107.366 148.204C109.987 144.108 115.454 142.876 119.604 145.448L130.403 153.253C134.538 155.849 135.78 161.265 133.185 165.377Z",
    fill: "url(#paint6_linear_9666_11602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.316 164.797C129.873 168.618 124.773 169.766 120.903 167.368L110.831 160.082C106.974 157.661 105.815 152.609 108.236 148.775C110.68 144.954 115.779 143.806 119.649 146.205L129.722 153.483C133.583 155.903 134.743 160.961 132.316 164.797Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.606 141.111C134.163 144.932 129.063 146.08 125.193 143.681L108.786 133.165C104.929 130.745 103.77 125.693 106.191 121.858C108.635 118.03 113.744 116.88 117.618 119.288L134.011 129.812C137.863 132.232 139.022 137.278 136.606 141.111Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.071 118.174C139.462 122.252 134.018 123.478 129.886 120.916L107.787 106.661C103.667 104.076 102.43 98.6785 105.019 94.5842C107.628 90.5056 113.072 89.2802 117.204 91.8417L139.303 106.097C143.423 108.682 144.66 114.08 142.071 118.174Z",
    fill: "url(#paint7_linear_9666_11602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.897 117.428C138.453 121.248 133.354 122.397 129.484 119.998L108.786 106.648C104.929 104.227 103.77 99.1754 106.191 95.3411C108.631 91.5078 113.741 90.3523 117.618 92.7577L138.315 106.108C142.175 108.533 143.329 113.594 140.897 117.428Z",
    fill: "#BE7C5E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9666_11602",
    x1: 120.527,
    y1: 93.5364,
    x2: 120.527,
    y2: 58.9405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9666_11602",
    x1: 174.971,
    y1: 218.239,
    x2: 174.971,
    y2: 151.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9666_11602",
    x1: 128.015,
    y1: 174.757,
    x2: 193.127,
    y2: 18.5142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9666_11602",
    x1: 161.034,
    y1: 139.587,
    x2: 161.034,
    y2: 42.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2EBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9666_11602",
    x1: 206.85,
    y1: 174.088,
    x2: 206.85,
    y2: 109.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9666_11602",
    x1: 121.404,
    y1: 145.774,
    x2: 121.404,
    y2: 117.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9666_11602",
    x1: 120.276,
    y1: 169.475,
    x2: 120.276,
    y2: 144.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9666_11602",
    x1: 123.545,
    y1: 122.254,
    x2: 123.545,
    y2: 90.5037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9666_11602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 314,
    height: 229,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaoComCelular);
export default __webpack_public_path__ + "static/media/mao-com-celular.8e093263a75c3df551496605f4a67251.svg";
export { ForwardRef as ReactComponent };